import { render } from "./WebcamPlayer.vue?vue&type=template&id=aa2bc3dc&scoped=true"
import script from "./WebcamPlayer.vue?vue&type=script&lang=js"
export * from "./WebcamPlayer.vue?vue&type=script&lang=js"

import "./WebcamPlayer.vue?vue&type=style&index=0&id=aa2bc3dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa2bc3dc"]])

export default __exports__